/** Shared HTTP helpers for IPC API modules. */
export const API_BASE_URL = (import.meta as any).env?.VITE_API_BASE_URL || 'http://localhost:5100/api/ipc';
const DEV_TEST_TOKEN = (import.meta as any).env?.VITE_DEV_TEST_TOKEN || '';

export const getAuthHeaders = (): HeadersInit => {
  const localToken = localStorage.getItem('access_token');
  const raw = (localToken && localToken.trim() ? localToken : DEV_TEST_TOKEN).trim();
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };
  if (raw) {
    headers['Authorization'] = /^Bearer\s+/i.test(raw) ? raw : `Bearer ${raw}`;
  }
  return headers;
};

/**
 * 统一处理接口响应，兼容两种后端格式：
 * 1. res_status_code/res_content（CoreBaseController）
 * 2. code/data
 */
export const handleResponse = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const data = await response.json();

  if (data.res_status_code !== undefined) {
    if (String(data.res_status_code) !== '0') {
      throw new Error(data.res_message || '请求失败');
    }
    return data.res_content as T;
  }

  if (data.code !== 200) {
    throw new Error(data.message || '请求失败');
  }
  return data.data as T;
};

/** 下载后端 File 响应（xlsx 等）；失败时尝试解析 JSON 错误信息。 */
export async function downloadFileResponse(response: Response, fallbackFileName: string): Promise<void> {
  if (!response.ok) {
    let msg = `下载失败 HTTP ${response.status}`;
    try {
      const data = await response.json();
      msg = data.res_message || data.message || msg;
    } catch {
      /* ignore */
    }
    throw new Error(msg);
  }

  const contentType = (response.headers.get('content-type') || '').toLowerCase();
  if (contentType.includes('application/json')) {
    const data = await response.json();
    if (data.res_status_code !== undefined && String(data.res_status_code) !== '0') {
      throw new Error(data.res_message || '导出失败');
    }
    if (data.code !== undefined && data.code !== 200) {
      throw new Error(data.message || '导出失败');
    }
    throw new Error('导出接口未返回文件');
  }

  const blob = await response.blob();
  let fileName = fallbackFileName;
  const disposition = response.headers.get('content-disposition') || '';
  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition);
  const plainMatch = /filename="?([^";]+)"?/i.exec(disposition);
  if (utf8Match?.[1]) {
    try {
      fileName = decodeURIComponent(utf8Match[1]);
    } catch {
      fileName = utf8Match[1];
    }
  } else if (plainMatch?.[1]) {
    fileName = plainMatch[1];
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
